import script from "./JobPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./JobPage.vue?vue&type=script&lang=ts&setup=true"

import "./JobPage.vue?vue&type=style&index=0&id=711092f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-711092f4"]])

export default __exports__